import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";

import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SessionItemSummaryComponent from "./sessionItemSummary.component";
import SessionActionButton from '../detail/sessionActionButton.component';
import { withRouter } from "react-router-dom";
import { Card, CardContent, CardHeader } from "@material-ui/core";

const styles = () => ({
  root: {
    border: "none",
    boxShadow: "none",
    padding: "0",
  },
  title: {
    margin: "5px 0px"
  },
  header: {
    background: 'radial-gradient(at top, #49b2ed, #1183e6)',
    boxShadow: 'none',
    paddingTop: '3px',
    paddingBottom: '0px',
    paddingLeft: '20px'
  },
  white: {
    color: 'white',

  },
  height: {
    minHeight: '175px',
  },
  table: {
    minWidth: "100%"
  },
  lastTable: {
    minWidth: "100%",
    marginBottom: "50px"
  },
  insidepanel: {
    padding: "0px"
  },
  pointer: {

    '&:hover': {
      cursor: 'pointer'
    }
  }
});

class SessionItemComponent extends React.Component {
  constructor(props) {
    super(props);

    let lastUsedSession = false;
    if (props.currentSessionId === props.session.id) {
      lastUsedSession = true;
    }

    /* eslint-disable max-len */
    const lastUsedFileJoined = _.filter(
      props.session.files,
      file => file.virtualFile && file.active && file.id === props.currentFileId
    );
    const lastUsedFileSource = _.filter(
      props.session.files,
      file =>
        !file.virtualFile && file.active && file.id === props.currentFileId
    );

    this.state = {
      expanded: lastUsedSession,
      joinedExpanded: lastUsedFileJoined && lastUsedFileJoined.length === 1,
      lastUsedFileJoinedId:
        lastUsedFileJoined && lastUsedFileJoined.length === 1
          ? lastUsedFileJoined[0].id
          : "",
      sourceExpanded: lastUsedFileSource && lastUsedFileSource.length === 1,
      lastUsedFileSourceId:
        lastUsedFileSource && lastUsedFileSource.length === 1
          ? lastUsedFileSource[0].id
          : ""
    };
    /* eslint-enable */

    this.goToProjectDetail = this.goToProjectDetail.bind(this);
    this.hideSession = this.hideSession.bind(this)
  }

  goToProjectDetail(event) {
    this.props.history.push(`/project/${this.props.session.id}`)
  }

  hideSession(){
    this.props.hideSession(this.props.session.id, !this.props.session.hide)
  }
  render() {
    const { session, classes } = this.props;

    return (
      <Grid item xs={12} md={6} lg={3}>
        <Card className={classes.height} expandicon={<ExpandMoreIcon />}>
          <CardHeader className={classes.header} classes={{ title: classes.white }} titleTypographyProps={{ variant: 'h6' }} title={session.name}
            action={<SessionActionButton session={session} white={true} hideSession={this.hideSession} hide={this.props.session.hide}></SessionActionButton>} />
          <CardContent className={classes.pointer} onClick={this.goToProjectDetail} >
            <SessionItemSummaryComponent
              session={session}
              numberOfFiles={
                _.filter(session.files, file => file.active && !file.missing)
                  .length
              }
              open={this.toggleEditNameActive}
            />
          </CardContent>
        </Card>
      </Grid>
    );
  }
}

SessionItemComponent.propTypes = {
  session: PropTypes.shape({
    id: PropTypes.string,
    createdAt: PropTypes.number,
    lastModified: PropTypes.number,
    name: PropTypes.string,
    hide: PropTypes.bool,
    files: PropTypes.shape({
      id: PropTypes.string,
      filename: PropTypes.string,
      lastModified: PropTypes.number,
      savedByUser: PropTypes.bool,
      missing: PropTypes.bool,
      joins: PropTypes.shape({
        sourceFilename: PropTypes.string
      })
    })
  }).isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
  currentSessionId: PropTypes.string.isRequired,
  currentFileId: PropTypes.string.isRequired,
  hideSession: PropTypes.func.isRequired,
};

export default withStyles(styles)(withRouter(SessionItemComponent));
